export function getOrderFoodTypeStatusColor(status: string) {
  switch (status.toLowerCase()) {
    case "completed":
      return "background: var(--order-card-status-completed-background); color: var(--order-card-status-completed-content);";
    case "ready":
      return "background: var(--order-card-status-ready-background); color: var(--order-card-status-ready-content);";
    case "preparing":
      return "background: var(--order-card-status-preparing-background); color: var(--order-card-status-preparing-content);";
    case "new":
      return "background: var(--order-card-status-new-background); color: var(--order-card-status-new-content);";
    case "hold":
      return "background: var(--order-card-status-hold-background); color: var(--order-card-status-hold-content);";
    default:
      return "background: var(--order-card-muted-content); color: var(--order-card-background);";
  }
}
